import {Injectable} from '@angular/core';
import {detect} from 'detect-browser';

@Injectable({
    providedIn: 'root'
})
export class DeviceHelperComponent {

    private _browser = detect();
    private _appVersion = require('../../../../package.json').version;

    constructor() {
    }

    getSsid() {
    }

    getDeviceName() {
    }

    isTablet(): boolean {
        return false;
    }

    getModel() {
    }

    getOsType() {
        return this._browser.os;
    }

    getOsVersion() {
    }

    getBrowserName() {
        return this._browser.name;
    }

    getBrowserVersion() {
        return this._browser.version;
    }

    getDeviceType() {
        return this._browser.type;
    }

    getApplicationVersion() {
        return this._appVersion;
    }

    backToPreviousPage() {

    }

    enableRotation() {
    }

    disableRotation() {
    }

    isiOS(): boolean {
        return false;
    }

    isAndroid(): boolean {
        return false;
    }

    setOrientation(direction: string) {
    }

    hideKeyboard() {
    }
}
